<div *ngIf="item" class="item-label">
  <glxy-avatar
    data-cy="product-icon"
    data-testid="item-icon"
    [name]="item.name"
    [src]="item.iconUrl"
    [width]="32"
  ></glxy-avatar>
  <div class="item-description">
    <div class="item-details">
      <span class="item-name-edition" data-testid="item-name">
        {{ item.name }}
        <span *ngIf="showEditionName && item.editionName" data-testid="item-edition">| {{ item.editionName }}</span>
      </span>
      <span *ngIf="item.quantity && item.quantity > 1" class="item-quantity">({{ item.quantity }})</span>
    </div>
    <span *ngIf="item.subtext" class="item-subtext" data-testid="item-subtext">{{ item.subtext }}</span>
    <span *ngIf="showItemId && item.itemId" class="item-id" data-testid="item-id">{{ item.itemId }}</span>
    <span
      *ngIf="showStatus && item.status"
      [ngClass]="item.status === 'Canceled' || item.status === 'Demo expired' ? 'status-canceled' : 'status'"
      data-testid="item-status"
    >
      {{ itemStatus | translate }}
    </span>
    <ng-content></ng-content>
  </div>
</div>
